
import { computed, defineComponent, getCurrentInstance, reactive, ref, onMounted, watch, onUnmounted } from "vue";

import GameService from "@/services/GameService";
import OnboardingChecklistService from "@/services/OnboardingChecklistService";
import ResponseData from "@/_models/ResponseData";
import { createToast, withProps } from "mosha-vue-toastify";
import qrcode from "qrcode-generator";
import { PublicAccount } from "tsjs-xpx-chain-sdk";
import { Helper } from "@/utils/Helper";
import useValidate from "@vuelidate/core";
import { required } from "@vuelidate/validators";
import { toast_emitter } from '@/layouts/home/emitter';

import image from "@/assets/images/user.png";
import onboarding from "@/assets/images/icon-onboarding.png";
import store from "@/store/index";
import { useStore } from 'vuex';
import { useRouter, useRoute } from "vue-router";
import { Peer } from "peerjs";

import { NotificationUtils } from "@/utils/NotificationUtils";
import CustomizedContent from "@/layouts/home/components/CustomizedContent.vue";
import layoutHomeAutoSignQRModal from "@/layouts/home/components/modals/layoutHomeAutoSignQRModal.vue";

export default defineComponent({
  data: function () {
    return {
      onboarding: onboarding,
      userData: store.getters["auth/user"] ?? "",
      jwtToken: store.getters["auth/jwtToken"] ?? "",
      onboardingChecklist: store.getters['onboarding/setChecklist'] ?? [],
      onboardingProgress: store.getters['onboarding/setProgress'] ?? 0,
      firstname: "",
      showToolTip: false,
      isDisplayCreateGameModal: false,
    };
  },
  components: {
    layoutHomeAutoSignQRModal
  },
  methods: {
    getOnboardingChecklist() {
      if (this.userData !== "") {
        OnboardingChecklistService.getOnboardingChecklist(this.userData.userId, this.jwtToken)
          .then((response: ResponseData) => {
            if (response.status === 200) {
              // console.log(response.data)
              response.data.items.forEach(function (item, index: number) {
                if (item.isDone) {
                  store.dispatch('onboarding/checklistTrue', index);
                }
              });
            store.dispatch('onboarding/progressCount');
            this.onboardingProgress = store.getters['onboarding/setProgress'];
            } else {
              this.createOnboardingChecklist();
            }
          })
          .catch((error) => {
            this.createOnboardingChecklist();
          });
      }
    },

    initializeOnboardingChecklist() {
      if (this.userData !== "") {
        OnboardingChecklistService.getOnboardingChecklist(this.userData.userId, this.jwtToken).then((response: ResponseData) => {
          if (response.status === 200) {
            let checklist = response.data.items;
            checklist[0].isDone = true;
            checklist[1].isDone = true;

            OnboardingChecklistService.updateOnboardingChecklist(this.userData.userId, this.jwtToken, checklist)
              .then(() => {
                this.getOnboardingChecklist();
              })
              .catch((error) => {
                console.log(error);
              });
          }
        });
      }
    },

    createOnboardingChecklist() {
      if (this.userData !== "") {
        OnboardingChecklistService.createOnboardingChecklist(this.userData.userId, this.jwtToken)
          .then(() => {
            this.initializeOnboardingChecklist();
          })
      }
    },

    getUserDetails() {
      if (this.userData !== "") {
        this.firstname = this.userData.firstName;
      }

      if (localStorage.getItem("tooltip")=='show') {
        this.showToolTip = true;
      }
    },

    hideToolTip() {
      this.showToolTip = false;
      localStorage.setItem("tooltip", "");
    },
  },

  computed: {
    isProgressUpdated() {
      return store.getters['onboarding/setProgress'];
    },
    appVersion(){
      return store.getters['config/appVersion'];
    },
    testnetLabel() {
      return store.getters['config/configTestnetLabel'];
    },
    mainnetLabel() {
      return store.getters['config/configMainnetLabel'];
    },
    assetUrl() {
      return store.getters['config/assetUrl'];
    },
    image() {
      return (this.userData.profilePicture)?this.assetUrl + 'blob/users/' + this.userData.username + '/' + this.userData.profilePicture:image;
    }
  },

  watch: {
    isProgressUpdated() {
      if (this.onboardingProgress !== store.getters['onboarding/setProgress']) {
        store.dispatch('onboarding/progressCount');
        this.onboardingProgress = store.getters['onboarding/setProgress'];
      }
    }
  },
  name: "headerComponent",
  mounted() {
    this.getOnboardingChecklist();
    this.getUserDetails();
  },
  created() {
    this.emitter.on('OPEN_CREATE_NEW_GAME_MODAL', (payload) => {
      this.isDisplayCreateGameModal = payload;
    })
    this.emitter.on('REFRESH_PROFILE_PHOTO', (payload) => {
      if(payload){
        this.userData = store.getters["auth/user"];
      }
    })
  },
  setup(){
    const internalInstance = getCurrentInstance();
    const emitter = internalInstance.appContext.config.globalProperties.emitter;
    const router = useRouter();
    const store = useStore();
    const route = useRoute();

    // autosigner
    const autoSignFunction = ref([]);
    const autoSignNotification = ref([]);
    const isQRModalOpened = ref(false);
    const qr = ref('');
    const title = ref('');
    const message = ref('');

    const toggleMenuInMobile = () => {
      if(store.getters['config/isDropDown']){
        store.dispatch('config/setDropDown', false);
      }else{
        store.dispatch('config/setDropDown', true);
      }
    }

    const logout = () => {
      store.dispatch('auth/removeStates');
      sessionStorage.removeItem('tourl');
      router.push({ path: '/login' });
    }

    let displayedNotification:string[] = [];
    const loadNotification = async(delayToastDisplay: number) => {
      const booleanAuthenticated = store.getters['auth/authenticated'];
      if(booleanAuthenticated){
        const noti = new NotificationUtils();
        const fetchedNotification = await noti.fetchNotifications();
        if(fetchedNotification.length > 0){
          let param = '';
          let numTimeDelayed = 0;
          let readNotication = 0;
          for(let loop = 0; loop < fetchedNotification.length; ++loop){
            if(!fetchedNotification[loop].isRead && !displayedNotification.includes(fetchedNotification[loop].notificationId)){
              ++readNotication;
              displayedNotification.push(fetchedNotification[loop].notificationId);
              numTimeDelayed += delayToastDisplay;
              setTimeout(() => {
                if(fetchedNotification[loop].isQR){
                  const { close } = createToast(
                    withProps(CustomizedContent, { title: fetchedNotification[loop].title, description: fetchedNotification[loop].message, notificationId: fetchedNotification[loop].notificationId, payload: fetchedNotification[loop].payload }),
                    {
                      position: "bottom-right",
                      type: "warning",
                      showCloseButton: true,
                      timeout: -1
                    }
                  );
                  autoSignFunction.value.push(close);
                  autoSignNotification.value.push(fetchedNotification[loop].notificationId);
                }else{
                  createToast(
                    {
                      title: fetchedNotification[loop].title,
                      description: fetchedNotification[loop].message,
                    },
                    {
                      position: "bottom-right",
                      type: "info",
                      timeout: 3000
                    }
                  );
                }

              }, numTimeDelayed);

              if(readNotication > 1){
                param += '&'
              }
              param += 'notificationId=' + fetchedNotification[loop].notificationId;
            }
          }
          if(readNotication){
            await noti.fetchReadNotification(param);
          }
        }
      }
    }

    var loadGameViewInterval:number;
    const initiateGameViewNotification = () => {
      loadGameViewInterval = window.setInterval( () => { loadNotification(400) }, 3000);
    }

    const clearGameViewNotification = () => {
      clearInterval(loadGameViewInterval)
    }

    var loadInterval:number;
    const initiateNotificationLoading = () => {
      loadInterval = window.setInterval( () => { loadNotification(5000) }, 10000);
    }

    const clearNotificationLoading = () => {
      clearInterval(loadInterval)
    }

    onUnmounted(() => {
      clearNotificationLoading()
    });

    onMounted(() => {
      initiateNotificationLoading();
      store.dispatch('game/playViewIsBlur');
    });

    watch(() => store.getters['game/isPlayViewFocus'], (isInGameView) => {
      if(isInGameView){
        initiateGameViewNotification()
      }else{
        clearGameViewNotification();
      }
    });

    const closeModal = () => {
      isQRModalOpened.value = false;
    }

    toast_emitter.on('OPEN_AUTO_SIGN_CUSTOM_MODAL', async(payload:any) => {
      message.value = payload.description;
      title.value = payload.title;
      const peer = new Peer();
      const secret = "this is a secret";
      const qrCode = qrcode(0, 'H');
      peer.on("open", (id) => {
        let data = {
          payload: payload.payload,
          type:'sign',
          recvId: peer.id,
          secret: secret,
          generationHash: store.getters['config/getTestnetGenerationHash'],
          callbackUrl: null
        }
        qrCode.addData(JSON.stringify(data));
        qrCode.make();
        qr.value = qrCode.createSvgTag({scalable: true});
      });
      peer.on("connection", (conn) => {
        conn.on("data", async(data: any) => {
          // validate the signature
          const signerPubAcc = PublicAccount.createFromPublicKey(data.publicKey, store.getters['config/getTestnetNetworkType']);
          const isValid = signerPubAcc.verifySignature(secret, data.signature);

          if (isValid) {
            const noti = new NotificationUtils();
            await noti.fetchReadNotification('notificationId=' + payload.notificationId);

            let notificationIndex = autoSignNotification.value.findIndex((noti) => noti === payload.notificationId);
            // console.log(notificationIndex)
            // console.log(autoSignFunction.value[notificationIndex]);
            autoSignFunction.value[notificationIndex]();
          }
        });
      });
      isQRModalOpened.value = true;
    });

    const isProfileDropDown = ref(false);
    // const isOverDropDown = ref(false);
    // const isHelpDropDown = ref(false);
    // const isOverDropDown.notification = ref(false);
    // const isCreateDropDown = ref(false);

    const isOverDropDown = ref({
      create: false,
      onBoarding: false,
      guide: false,
      notification: false,
      profile: false
    });

    const isDropDown = ref({
      create: false,
      onBoarding: false,
      guide: false,
      notification: false,
      profile: false
    });

    const objOverDropDown = reactive({ isOverDropDown });

    /* To reset drop down in header */
    const resetDropDown = (dropdownType: string) => {
      if(dropdownType != 'profile'){
        isDropDown.value.profile = false;
      if(dropdownType != 'onBoard'){
        isDropDown.value.onBoarding = false;
      }}
      if(dropdownType != 'help'){
        isDropDown.value.guide = false;
      }
      if(dropdownType != 'notification'){
        isDropDown.value.notification = false;
      }
      if(dropdownType != 'create'){
        isDropDown.value.create = false;
      }
    }

    emitter.on('PAGE_CLICK', () => {
      for (const [key, item] of Object.entries(isOverDropDown.value)) {
        if(!isOverDropDown.value[key]){
          isDropDown.value[key] = false;
        }
      }
    });

    const state = ref({
      gameTitle: "",
    });

    const credentials = ref({
      userData: store.getters["auth/user"] ?? "",
      jwtToken: store.getters["auth/jwtToken"] ?? "",
    });

    const namespaces = ref({
      selectedNamespace: {
        domain: "",
        namespaceId: "",
      },
      namespaceName: "",
      namespacesList: [],
    });

    const stepper = ref({
      step1: true,
      step2: false,
    });

    const rules = computed(() => {
      return {
        gameTitle: { required },
      };
    });

    const v$ = useValidate(rules, state);
    // code for stepper
    const jumpToStep = (itemClicked: any) => {
      v$.value.$validate();
      if (!v$.value.$error) {
        if (itemClicked == 1) {
          stepper.value.step1 = true;
          stepper.value.step2 = false;
        } else if (itemClicked == 2) {
          stepper.value.step2 = true;
          isShowFetchingNamespace.value = true;
          getNamespacesList();
        }
      }
    };

    const createGame = () => {
      if (credentials.value.userData !== "" && credentials.value.jwtToken !== "") {
        let formData = new FormData();

        if (state.value.gameTitle !== "") {
          formData.append("Title", state.value.gameTitle);
          formData.append("Name", namespaces.value.selectedNamespace.domain);

          GameService.createGame(credentials.value.userData.userId, credentials.value.jwtToken, formData)
            .then((response: ResponseData) => {
              createToast(
                {
                  title: "Yay!",
                  description: response.data["message"] ? response.data["message"] : response.data,
                },
                {
                  position: "bottom-right",
                  type: "success",
                }
              );
              updateOnboardingChecklist(credentials.value.userData.userId, credentials.value.jwtToken);
              getNamespacesList();

              if (route.name === 'viewGamesList') {
                store.dispatch("game/addGame", "1");
              } else {
                router.push({name: 'viewGamesList'});
              }
              emitter.emit('OPEN_CREATE_NEW_GAME_MODAL', false);
              stepper.value.step1 = true;
              stepper.value.step2 = false;
              state.value.gameTitle = '';
            })
            .catch((error) => {
              console.log(error);
              Helper.endpointErrorHandling(error);
            });
        } else {
          createToast(
            {
              title: "Whoops!",
              description: "Game Title is empty!",
            },
            {
              position: "bottom-right",
              type: "danger",
            }
          );
        }
      }
    };

    const isNamespaceError = ref(false);
    const isShowFetchingNamespace = ref(false);
    const getNamespacesList = () => {
      if (credentials.value.userData !== "") {
        isShowFetchingNamespace.value = true;
        // let userData = JSON.parse(user);
        GameService.getNamespaceList(credentials.value.userData.testnetWalletAddress)
          .then((response: ResponseData) => {
            namespaces.value.namespacesList = response.data;
            isShowFetchingNamespace.value = false;
            // console.log(namespaces.value.namespacesList);
          })
          .catch((error) => {
            Helper.endpointErrorHandling(error);
            isNamespaceError.value = true;
            isShowFetchingNamespace.value = false;
          });
      }
    };

    const chooseNamespace = (namespace: any) => {
      namespaces.value.selectedNamespace.domain = namespace.name;
      namespaces.value.selectedNamespace.namespaceId = namespace.namespaceId;
    };

    const updateOnboardingChecklist = (userId: string, token: string) => {
      OnboardingChecklistService.getOnboardingChecklist(userId, token)
        .then((response: ResponseData) => {
          OnboardingChecklistService.saveUpdatedOnboardingChecklist(response.data.items, 5, userId, token);
        })
        .catch((error) => {
          Helper.endpointErrorHandling(error);
        });
    };

    return{
      resetDropDown,
      logout,
      toggleMenuInMobile,
      isProfileDropDown,
      isOverDropDown,
      isDropDown,
      chooseNamespace,
      getNamespacesList,
      isNamespaceError,
      jumpToStep,
      createGame,
      state,
      v$,
      stepper,
      credentials,
      namespaces,
      isShowFetchingNamespace,

      isQRModalOpened,
      qr,
      title,
      message,
      closeModal,
    }
  }
});
